<template>
  <div>
    <el-date-picker
      :id="id"
      type="month"
      v-model="model"
      @change="select"
      ref="pickerDateInput"
      format="MM/yyyy"
      :disabled="disabled"
      :editable="editable"
      class="fix-padding-right"
      :placeholder="placeholder"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import 'element-ui/lib/theme-chalk/index.css'
import { DatePicker } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/pt-br'
import locale from 'element-ui/lib/locale'

locale.use(lang)
Vue.use(DatePicker)

export default {
  name: 'input-data-mes',
  props: ['value', 'placeholder', 'icon', 'disabled', 'editable', 'id'],
  inheritAttrs: false,
  data() {
    return {
      model: ''
    }
  },
  mounted() {
    this.model = this.value
    this.addNewFunctionParser()
  },
  methods: {
    select(value) {
      const data = value ? moment(value).format('YYYY-MM-DD') : null
      this.$emit('input', data)
    },
    addNewFunctionParser() {
      this.$nextTick(() => {
        const elPicker = this.$refs.pickerDateInput
        const originalParseFunction = elPicker.parseString
        const newParseFunction = this.expandNumbersToDate
        elPicker.parseString = function(value) {
          value = newParseFunction(value)
          return originalParseFunction(value)
        }
      })
    },
    expandNumbersToDate(value) {
      const currentMonth = moment().format('MM')
      const currentYear = moment().format('YYYY')
      value = '01' + value
      value = value.replace(/^[^\d]*(\d{2})[^\d]*$/, `$1/${currentMonth}/${currentYear}`)
      value = value.replace(/^[^\d]*(\d{2})(\d{2})[^\d]*$/, `$1/$2/${currentYear}`)
      value = value.replace(/^[^\d]*(\d{2})\/?(\d{2})\/?(\d{4})[^\d]*$/, '$2/$3')
      return value
    }
  },

  watch: {
    value(vl) {
      this.model = moment(vl).format()
    }
  }
}
</script>

<style lang="css">
.fix-padding-right > .el-input__inner {
  padding-right: unset !important;
}

.el-input {
  width: 100% !important;
}
</style>
